// import React, { useEffect, useState } from "react";
// import {
//   Table, Button, Tag, Card, Layout, Typography,
//   Space, message, Modal, Image, Input, Tooltip,
// } from "antd";
// import {
//   CheckOutlined, CloseOutlined, EyeOutlined, MenuOutlined,
// } from "@ant-design/icons";
// import axios from "axios";
// import { BASE_URL } from "../../Config";
// import Sidebar from "../../Components/Sidebar";

// const { Header } = Layout;
// const { Text } = Typography;
// const { TextArea } = Input;

// const TIERS = [
//   { min: 1_000_000, label: ">1M" },
//   { min: 100_000,   label: ">100k" },
//   { min: 50_000,    label: ">50k" },
//   { min: 10_000,    label: ">10k" },
//   { min: 1_000,     label: ">1k" },
// ];

// function getTierLabel(count) {
//   return TIERS.find(t => count >= t.min)?.label ?? "—";
// }

// const FollowerBonusApproval = () => {
//   const [data, setData]               = useState([]);
//   const [loading, setLoading]         = useState(true);
//   const [collapsed, setCollapsed]     = useState(false);
//   const [isMobile, setIsMobile]       = useState(false);
//   const [mobileOpen, setMobileOpen]   = useState(false);
//   const [approvingId, setApprovingId] = useState(null);

//   // Screenshot viewer modal
//   const [proofModal, setProofModal]         = useState(false);
//   const [selectedClaim, setSelectedClaim]   = useState(null);

//   // Reject modal
//   const [rejectModal, setRejectModal]     = useState(false);
//   const [rejectTarget, setRejectTarget]   = useState(null);
//   const [rejectLoading, setRejectLoading] = useState(false);

//   const [statusFilter, setStatusFilter] = useState("pending");

//   const token = sessionStorage.getItem("token");
//   const headers = { Authorization: `Bearer ${token}` };

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   useEffect(() => { fetchClaims(); }, [statusFilter]);

//   const fetchClaims = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${BASE_URL}/follower-bonus/claims?status=${statusFilter}`,
//         { headers }
//       );
//       setData(res.data.claims || []);
//     } catch {
//       message.error("Failed to load follower bonus claims");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApprove = async (record) => {
//     try {
//       setApprovingId(record._id);
//       await axios.patch(
//         `${BASE_URL}/follower-bonus/claims/${record._id}/approve`,
//         {},
//         { headers }
//       );
//       message.success(`Approved — +${record.bonusDays} days added to all variations`);
//       setProofModal(false);
//       fetchClaims();
//     } catch (err) {
//       message.error(err.response?.data?.message ?? "Approval failed");
//     } finally {
//       setApprovingId(null);
//     }
//   };

//   const handleReject = async () => {
//     try {
//       setRejectLoading(true);
//       await axios.patch(
//         `${BASE_URL}/follower-bonus/claims/${rejectTarget._id}/reject`,
//         {},
//         { headers }
//       );
//       message.success("Claim rejected");
//       setRejectModal(false);
//       setProofModal(false);
//       fetchClaims();
//     } catch (err) {
//       message.error(err.response?.data?.message ?? "Rejection failed");
//     } finally {
//       setRejectLoading(false);
//     }
//   };

//   const columns = [
//     {
//       title: "User ID",
//       dataIndex: "userId",
//       render: (id, r) => (
//         <>
//           <div><strong style={{ fontSize: 13 }}>{id}</strong></div>
//           <small style={{ color: "#888" }}>
//             {new Date(r.createdAt).toLocaleDateString()}
//           </small>
//         </>
//       ),
//     },
//     {
//       title: "Platform",
//       dataIndex: "platform",
//       render: (p) => <Tag color="blue">{p}</Tag>,
//     },
//     {
//       title: "Followers",
//       dataIndex: "followerCount",
//       render: (count) => (
//         <Space direction="vertical" size={2}>
//           <Text strong>{Number(count).toLocaleString()}</Text>
//           <Tag color="purple">{getTierLabel(count)}</Tag>
//         </Space>
//       ),
//       sorter: (a, b) => a.followerCount - b.followerCount,
//     },
//     {
//       title: "Bonus",
//       dataIndex: "bonusDays",
//       render: (days, r) => (
//         <Space direction="vertical" size={2}>
//           <Tag color="green">+{days} days</Tag>
//           {r.withLogo && <Tag color="orange">With Logo</Tag>}
//         </Space>
//       ),
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       render: (s) => (
//         <Tag color={s === "approved" ? "green" : s === "rejected" ? "red" : "orange"}
//           style={{ borderRadius: 20, padding: "2px 12px", fontWeight: 600 }}>
//           {s.toUpperCase()}
//         </Tag>
//       ),
//     },
//     {
//       title: "Screenshot",
//       render: (_, r) => (
//         <Button icon={<EyeOutlined />} size="small"
//           onClick={() => { setSelectedClaim(r); setProofModal(true); }}>
//           View
//         </Button>
//       ),
//     },
//     {
//       title: "Actions",
//       render: (_, record) => (
//         <Space>
//           <Tooltip title="Approve — adds bonus days to all user variations">
//             <Button type="primary" icon={<CheckOutlined />}
//               loading={approvingId === record._id}
//               disabled={record.status !== "pending"}
//               onClick={() => handleApprove(record)}
//               style={{ background: "#10b981", borderColor: "#10b981" }}>
//               Approve
//             </Button>
//           </Tooltip>
//           <Button danger icon={<CloseOutlined />}
//             disabled={record.status !== "pending"}
//             onClick={() => { setRejectTarget(record); setRejectModal(true); }}>
//             Reject
//           </Button>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//       <Sidebar
//         collapsed={collapsed} setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen} setMobileOpen={setMobileOpen}
//         isMobile={isMobile} collapsedWidth="0" role="admin"
//       />
//       <Layout
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//           transition: "0.3s", padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header className="MainHeader">
//           {isMobile && (
//             <Button type="text" icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }} />
//           )}
//           <div style={{ flex: 1 }}>
//             <Text style={{ fontSize: 20, fontWeight: "bold" }}>
//               🏆 Follower Bonus Claims
//             </Text>
//           </div>
//           <Space>
//             {/* Status filter tabs */}
//             {["pending", "approved", "rejected"].map(s => (
//               <Button key={s}
//                 type={statusFilter === s ? "primary" : "default"}
//                 onClick={() => setStatusFilter(s)}
//                 style={statusFilter === s ? { background: "#4f46e5", borderColor: "#4f46e5" } : {}}>
//                 {s.charAt(0).toUpperCase() + s.slice(1)}
//               </Button>
//             ))}
//             <Tag color="orange" style={{ fontSize: 14, padding: "4px 12px" }}>
//               {data.length} {statusFilter}
//             </Tag>
//             <Button onClick={fetchClaims}>Refresh</Button>
//           </Space>
//         </Header>

//         <Card style={{ borderRadius: 12 }}>
//           <Table
//             columns={columns} dataSource={data}
//             rowKey="_id" loading={loading}
//             pagination={{ pageSize: 10 }} scroll={{ x: 800 }}
//           />
//         </Card>
//       </Layout>

//       {/* ── Screenshot Modal ── */}
//       <Modal
//         title={`Follower Proof — ${selectedClaim?.platform} · ${Number(selectedClaim?.followerCount ?? 0).toLocaleString()} followers`}
//         open={proofModal}
//         onCancel={() => setProofModal(false)}
//         width={600} centered
//         footer={
//           selectedClaim?.status === "pending" ? (
//             <Space>
//               <Button type="primary" icon={<CheckOutlined />}
//                 loading={approvingId === selectedClaim?._id}
//                 onClick={() => handleApprove(selectedClaim)}
//                 style={{ background: "#10b981", borderColor: "#10b981" }}>
//                 Approve (+{selectedClaim?.bonusDays} days)
//               </Button>
//               <Button danger icon={<CloseOutlined />}
//                 onClick={() => { setProofModal(false); setRejectTarget(selectedClaim); setRejectModal(true); }}>
//                 Reject
//               </Button>
//             </Space>
//           ) : null
//         }
//       >
//         {selectedClaim && (
//           <>
//             <Card size="small" style={{ marginBottom: 16, background: "#f9fafb" }}>
//               {[
//                 { label: "Platform",   value: selectedClaim.platform },
//                 { label: "Profile",    value: <a href={selectedClaim.socialMediaUrl} target="_blank" rel="noreferrer">{selectedClaim.socialMediaUrl}</a> },
//                 { label: "Followers",  value: Number(selectedClaim.followerCount).toLocaleString() },
//                 { label: "Tier",       value: <Tag color="purple">{getTierLabel(selectedClaim.followerCount)}</Tag> },
//                 { label: "Bonus",      value: <Tag color="green">+{selectedClaim.bonusDays} days</Tag> },
//                 { label: "With Logo",  value: selectedClaim.withLogo ? "Yes" : "No" },
//                 { label: "Submitted",  value: new Date(selectedClaim.createdAt).toLocaleString() },
//               ].map(({ label, value }) => (
//                 <div key={label} style={{
//                   display: "flex", justifyContent: "space-between",
//                   padding: "5px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13,
//                 }}>
//                   <Text type="secondary">{label}</Text>
//                   <Text strong>{value}</Text>
//                 </div>
//               ))}
//             </Card>

//             <div style={{ fontWeight: 600, marginBottom: 10 }}>Screenshot:</div>
//             <Image
//               src={selectedClaim.screenshotUrl}
//               style={{ borderRadius: 8, border: "1px solid #e5e7eb", maxWidth: "100%" }}
//             />
//           </>
//         )}
//       </Modal>

//       {/* ── Reject Modal ── */}
//       <Modal
//         title="Reject Claim" open={rejectModal}
//         onCancel={() => setRejectModal(false)}
//         centered
//         footer={
//           <Space>
//             <Button onClick={() => setRejectModal(false)}>Cancel</Button>
//             <Button danger loading={rejectLoading} onClick={handleReject}>
//               Confirm Reject
//             </Button>
//           </Space>
//         }
//       >
//         <Text type="secondary" style={{ fontSize: 13, display: "block", marginBottom: 10 }}>
//           Rejecting claim for <strong>{Number(rejectTarget?.followerCount ?? 0).toLocaleString()}</strong> followers on <strong>{rejectTarget?.platform}</strong>.
//         </Text>
//       </Modal>
//     </Layout>
//   );
// };

// export default FollowerBonusApproval;

import React, { useEffect, useState } from "react";
import {
  Table, Button, Tag, Card, Layout, Typography,
  Space, message, Modal, Image, Tooltip, Divider,
} from "antd";
import {
  CheckOutlined, CloseOutlined, EyeOutlined,
  MenuOutlined, ReloadOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../../Config";
import Sidebar from "../../Components/Sidebar";

const { Header, Content } = Layout;
const { Text } = Typography;

const TIERS = [
  { min: 1_000_000, label: ">1M" },
  { min: 100_000,   label: ">100k" },
  { min: 50_000,    label: ">50k" },
  { min: 10_000,    label: ">10k" },
  { min: 1_000,     label: ">1k" },
];

function getTierLabel(count) {
  return TIERS.find((t) => count >= t.min)?.label ?? "—";
}

const STATUS_COLORS = { approved: "green", rejected: "red", pending: "orange" };

const FollowerBonusApproval = () => {
  const [data, setData]               = useState([]);
  const [loading, setLoading]         = useState(true);
  const [collapsed, setCollapsed]     = useState(false);
  const [isMobile, setIsMobile]       = useState(false);
  const [mobileOpen, setMobileOpen]   = useState(false);
  const [approvingId, setApprovingId] = useState(null);
  const [statusFilter, setStatusFilter] = useState("pending");

  const [proofModal, setProofModal]       = useState(false);
  const [selectedClaim, setSelectedClaim] = useState(null);

  const [rejectModal, setRejectModal]     = useState(false);
  const [rejectTarget, setRejectTarget]   = useState(null);
  const [rejectLoading, setRejectLoading] = useState(false);

  const token = sessionStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => { fetchClaims(); }, [statusFilter]);

  const fetchClaims = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${BASE_URL}/follower-bonus/claims?status=${statusFilter}`,
        { headers }
      );
      setData(res.data.claims || []);
    } catch {
      message.error("Failed to load follower bonus claims");
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (record) => {
    try {
      setApprovingId(record._id);
      await axios.patch(
        `${BASE_URL}/follower-bonus/claims/${record._id}/approve`,
        {}, { headers }
      );
      message.success(`Approved — +${record.bonusDays} days added to all variations`);
      setProofModal(false);
      fetchClaims();
    } catch (err) {
      message.error(err.response?.data?.message ?? "Approval failed");
    } finally {
      setApprovingId(null);
    }
  };

  const handleReject = async () => {
    try {
      setRejectLoading(true);
      await axios.patch(
        `${BASE_URL}/follower-bonus/claims/${rejectTarget._id}/reject`,
        {}, { headers }
      );
      message.success("Claim rejected");
      setRejectModal(false);
      setProofModal(false);
      fetchClaims();
    } catch (err) {
      message.error(err.response?.data?.message ?? "Rejection failed");
    } finally {
      setRejectLoading(false);
    }
  };

  const openProof = (record) => { setSelectedClaim(record); setProofModal(true); };
  const openReject = (record) => { setRejectTarget(record); setRejectModal(true); };

  // ── Desktop columns ──────────────────────────────────────
  const columns = [
    {
      title: "User ID",
      dataIndex: "userId",
      render: (id, r) => (
        <>
          <div><strong style={{ fontSize: 13 }}>{id}</strong></div>
          <small style={{ color: "#888" }}>{new Date(r.createdAt).toLocaleDateString()}</small>
        </>
      ),
    },
    {
      title: "Platform",
      dataIndex: "platform",
      render: (p) => <Tag color="blue">{p}</Tag>,
    },
    {
      title: "Followers",
      dataIndex: "followerCount",
      render: (count) => (
        <Space direction="vertical" size={2}>
          <Text strong>{Number(count).toLocaleString()}</Text>
          <Tag color="purple">{getTierLabel(count)}</Tag>
        </Space>
      ),
      sorter: (a, b) => a.followerCount - b.followerCount,
    },
    {
      title: "Bonus",
      dataIndex: "bonusDays",
      render: (days, r) => (
        <Space direction="vertical" size={2}>
          <Tag color="green">+{days} days</Tag>
          {r.withLogo && <Tag color="orange">With Logo</Tag>}
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (s) => (
        <Tag color={STATUS_COLORS[s]}
          style={{ borderRadius: 20, padding: "2px 12px", fontWeight: 600 }}>
          {s.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: "Screenshot",
      render: (_, r) => (
        <Button icon={<EyeOutlined />} size="small" onClick={() => openProof(r)}>
          View
        </Button>
      ),
    },
    {
      title: "Actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Approve — adds bonus days to all user variations">
            <Button type="primary" icon={<CheckOutlined />}
              loading={approvingId === record._id}
              disabled={record.status !== "pending"}
              onClick={() => handleApprove(record)}
              style={{ background: "#10b981", borderColor: "#10b981" }}>
              Approve
            </Button>
          </Tooltip>
          <Button danger icon={<CloseOutlined />}
            disabled={record.status !== "pending"}
            onClick={() => openReject(record)}>
            Reject
          </Button>
        </Space>
      ),
    },
  ];

  // ── Mobile claim card ────────────────────────────────────
  const MobileCard = ({ record }) => {
    const isPending = record.status === "pending";
    return (
      <Card
        style={{ marginBottom: 12, borderRadius: 12, boxShadow: "0 1px 6px rgba(0,0,0,0.08)" }}
        bodyStyle={{ padding: "14px 16px" }}
      >
        {/* Row 1 – User + Status */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div style={{ flex: 1, minWidth: 0, paddingRight: 8 }}>
            <Text strong style={{ fontSize: 14, display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {record.userId}
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {new Date(record.createdAt).toLocaleDateString()}
            </Text>
          </div>
          <Tag color={STATUS_COLORS[record.status]}
            style={{ borderRadius: 20, padding: "2px 10px", fontWeight: 600, flexShrink: 0 }}>
            {record.status.toUpperCase()}
          </Tag>
        </div>

        {/* Row 2 – Tags */}
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
          <Tag color="blue">{record.platform}</Tag>
          <Tag color="purple">{getTierLabel(record.followerCount)}</Tag>
          <Tag color="green">+{record.bonusDays} days</Tag>
          {record.withLogo && <Tag color="orange">With Logo</Tag>}
        </div>

        {/* Row 3 – Follower count */}
        <div style={{ background: "#f9fafb", borderRadius: 8, padding: "6px 12px", marginBottom: 10 }}>
          <Text type="secondary" style={{ fontSize: 11 }}>Followers</Text>
          <Text strong style={{ display: "block", fontSize: 16 }}>
            {Number(record.followerCount).toLocaleString()}
          </Text>
        </div>

        {/* Row 4 – Actions */}
        <div style={{ display: "flex", gap: 8 }}>
          <Button
            icon={<EyeOutlined />}
            onClick={() => openProof(record)}
            style={{ flex: "1 1 0" }}
          >
            Screenshot
          </Button>
          <Button
            type="primary"
            icon={<CheckOutlined />}
            loading={approvingId === record._id}
            disabled={!isPending}
            onClick={() => handleApprove(record)}
            style={{ flex: "1 1 0", background: "#10b981", borderColor: "#10b981" }}
          >
            Approve
          </Button>
          <Button
            danger
            icon={<CloseOutlined />}
            disabled={!isPending}
            onClick={() => openReject(record)}
            style={{ flex: "1 1 0" }}
          >
            Reject
          </Button>
        </div>
      </Card>
    );
  };

  const sidebarWidth = isMobile ? 0 : collapsed ? 0 : 240;

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed} setCollapsed={setCollapsed}
        mobileOpen={mobileOpen} setMobileOpen={setMobileOpen}
        isMobile={isMobile} collapsedWidth="0" role="admin"
      />

      <Layout style={{ marginLeft: sidebarWidth, transition: "margin-left 0.3s" }}>

        {/* ── Header ── */}
        <Header
          style={{
            background: "#fff",
            padding: isMobile ? "0 12px" : "0 24px",
            height: "auto",
            minHeight: 64,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            borderBottom: "1px solid #f0f0f0",
            position: "sticky",
            top: 0,
            zIndex: 100,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          {/* Hamburger + Title */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, flex: "1 1 auto", minWidth: 0 }}>
            {isMobile && (
              <Button
                type="text" icon={<MenuOutlined />}
                onClick={() => setMobileOpen(true)}
                style={{ fontSize: 18, padding: 0, flexShrink: 0 }}
              />
            )}
            <Text strong style={{ fontSize: isMobile ? 15 : 20, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
               Follower Bonus Claims
            </Text>
          </div>

          {/* Controls */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              flexWrap: "wrap",
              width: isMobile ? "100%" : "auto",
              paddingBottom: isMobile ? 8 : 0,
            }}
          >
            {["pending", "approved", "rejected"].map((s) => (
              <Button
                key={s}
                type={statusFilter === s ? "primary" : "default"}
                onClick={() => setStatusFilter(s)}
                style={{
                  flex: isMobile ? "1 1 0" : "none",
                  ...(statusFilter === s ? { background: "#4f46e5", borderColor: "#4f46e5" } : {}),
                }}
              >
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </Button>
            ))}
            <Tag
              color="orange"
              style={{ fontSize: 13, padding: "4px 10px", flex: isMobile ? "1 1 0" : "none", textAlign: "center" }}
            >
              {data.length} {statusFilter}
            </Tag>
            <Button
              icon={<ReloadOutlined />}
              loading={loading}
              onClick={fetchClaims}
              style={{ flex: isMobile ? "1 1 100%" : "none" }}
            >
              Refresh
            </Button>
          </div>
        </Header>

        {/* ── Content ── */}
        <Content style={{ padding: isMobile ? "12px 10px" : "20px 24px" }}>
          {isMobile ? (
            loading ? (
              <div style={{ textAlign: "center", padding: 40 }}>
                <Text type="secondary">Loading…</Text>
              </div>
            ) : data.length === 0 ? (
              <Card style={{ borderRadius: 12, textAlign: "center" }}>
                <Text type="secondary">No {statusFilter} claims.</Text>
              </Card>
            ) : (
              data.map((record) => <MobileCard key={record._id} record={record} />)
            )
          ) : (
            <Card style={{ borderRadius: 12 }}>
              <Table
                columns={columns} dataSource={data}
                rowKey="_id" loading={loading}
                pagination={{ pageSize: 10 }} scroll={{ x: 800 }}
              />
            </Card>
          )}
        </Content>
      </Layout>

      {/* ── Screenshot Modal ── */}
      <Modal
        title={
          selectedClaim
            ? `${selectedClaim.platform} · ${Number(selectedClaim.followerCount ?? 0).toLocaleString()} followers`
            : "Follower Proof"
        }
        open={proofModal}
        onCancel={() => setProofModal(false)}
        width={isMobile ? "95vw" : 600}
        style={isMobile ? { top: 16 } : {}}
        centered={!isMobile}
        footer={
          selectedClaim?.status === "pending" ? (
            <Space style={{ width: "100%", justifyContent: isMobile ? "stretch" : "flex-end" }}>
              <Button
                type="primary" icon={<CheckOutlined />}
                loading={approvingId === selectedClaim?._id}
                onClick={() => handleApprove(selectedClaim)}
                style={{ background: "#10b981", borderColor: "#10b981", flex: isMobile ? 1 : "none" }}
              >
                Approve (+{selectedClaim?.bonusDays} days)
              </Button>
              <Button
                danger icon={<CloseOutlined />}
                onClick={() => { setProofModal(false); openReject(selectedClaim); }}
                style={{ flex: isMobile ? 1 : "none" }}
              >
                Reject
              </Button>
            </Space>
          ) : null
        }
      >
        {selectedClaim && (
          <>
            <Card size="small" style={{ marginBottom: 16, background: "#f9fafb" }}>
              {[
                { label: "Platform",  value: selectedClaim.platform },
                {
                  label: "Profile",
                  value: (
                    <a href={selectedClaim.socialMediaUrl} target="_blank" rel="noreferrer"
                      style={{ wordBreak: "break-all", fontSize: 12 }}>
                      {selectedClaim.socialMediaUrl}
                    </a>
                  ),
                },
                { label: "Followers", value: Number(selectedClaim.followerCount).toLocaleString() },
                { label: "Tier",      value: <Tag color="purple">{getTierLabel(selectedClaim.followerCount)}</Tag> },
                { label: "Bonus",     value: <Tag color="green">+{selectedClaim.bonusDays} days</Tag> },
                { label: "With Logo", value: selectedClaim.withLogo ? "Yes" : "No" },
                { label: "Submitted", value: new Date(selectedClaim.createdAt).toLocaleString() },
              ].map(({ label, value }) => (
                <div key={label} style={{
                  display: "flex", justifyContent: "space-between", alignItems: "flex-start",
                  padding: "5px 0", borderBottom: "1px solid #f3f4f6", fontSize: 13, gap: 8,
                }}>
                  <Text type="secondary" style={{ flexShrink: 0 }}>{label}</Text>
                  <Text strong style={{ textAlign: "right" }}>{value}</Text>
                </div>
              ))}
            </Card>

            <div style={{ fontWeight: 600, marginBottom: 10 }}>Screenshot:</div>
            <Image
              src={selectedClaim.screenshotUrl}
              style={{ borderRadius: 8, border: "1px solid #e5e7eb", maxWidth: "100%" }}
            />
          </>
        )}
      </Modal>

      {/* ── Reject Modal ── */}
      <Modal
        title="Reject Claim"
        open={rejectModal}
        onCancel={() => setRejectModal(false)}
        width={isMobile ? "92vw" : 420}
        style={isMobile ? { top: 24 } : {}}
        centered={!isMobile}
        footer={
          <Space style={{ width: "100%", justifyContent: isMobile ? "stretch" : "flex-end" }}>
            <Button onClick={() => setRejectModal(false)} style={{ flex: isMobile ? 1 : "none" }}>
              Cancel
            </Button>
            <Button danger loading={rejectLoading} onClick={handleReject} style={{ flex: isMobile ? 1 : "none" }}>
              Confirm Reject
            </Button>
          </Space>
        }
      >
        <Text type="secondary" style={{ fontSize: 13, display: "block", marginBottom: 4 }}>
          Rejecting claim for{" "}
          <strong>{Number(rejectTarget?.followerCount ?? 0).toLocaleString()}</strong>{" "}
          followers on <strong>{rejectTarget?.platform}</strong>.
        </Text>
        <Text type="secondary" style={{ fontSize: 12 }}>This action cannot be undone.</Text>
      </Modal>
    </Layout>
  );
};

export default FollowerBonusApproval;